// When navigating to new routes where we only update one part of the route, we can't necessarily just pass a partial
// route (i.e. update the hash only), as this would have strange behavior in some cases, like if we set the 'to'
// parameter of a v-btn to the object { hash: '#something' stack: 1 }. Under the hood, that 'stack' parameter gets
// stripped off before reaching our monkey-patched 'push' function. We also can't simply use the pattern { ...$route,
// hash: '#something', stack: 1 }, since '$route' might be a recursive object. This function allows us to easily extend
// the current route by extracting only the relevant parameters, so our example becomes: $routeAssign({ hash:
// '#something', stack: 1 })

export default {
  methods: {
    $routeAssign(updated) {
      return Object.assign(_.pick(this.$route, [ 'name', 'params', 'hash', 'query' ]), updated);
    }
  }
};
